import styled from 'styled-components';

export const SalesWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default SalesWrapper;
